import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Box,
} from "@mui/material";
import {
  validateNumber,
  validateNumberInput,
} from "../../../../utils/validateFields";

const ComplaintTable = ({
  formData,
  setFormData,
  errors,
  setErrors,
  disabled,
}) => {
  // Initial State
  //   const [formData, setFormData] = useState({
  //     currentFinancialYear: {
  //       directors: { numberOfComplaints: "", remarks: "" },
  //       keyManagement: { numberOfComplaints: "", remarks: "" },
  //     },
  //     previousFinancialYear: {
  //       directors: { numberOfComplaints: "", remarks: "" },
  //       keyManagement: { numberOfComplaints: "", remarks: "" },
  //     },
  //   });

  // Validation State
  //   const [errors, setErrors] = useState({});

  console.log(errors);

  // Handle Input Change
  const handleRowChange = (year, role, field, value) => {
    if (field === "numberOfComplaints" && !validateNumberInput(value)) return;
    setFormData((prev) => ({
      ...prev,
      conflictOfInterestComplaints: {
        ...prev.conflictOfInterestComplaints,
        [year]: {
          ...prev.conflictOfInterestComplaints?.[year],
          [role]: {
            ...prev.conflictOfInterestComplaints?.[year]?.[role],
            [field]: value,
          },
        },
      },
    }));

    // Clear validation error for the field
    setErrors((prev) => {
      const updatedErrors = { ...prev };
      if (updatedErrors[role]?.[year]?.[field]) {
        delete updatedErrors[role][year][field];
      }
      return updatedErrors;
    });
  };

  // Generate Row Error Messages
  const getRowErrorMessages = () => {
    const groupedErrors = {};

    Object.keys(errors).forEach((year) => {
      Object.keys(errors[year]).forEach((role) => {
        if (!groupedErrors[year]) groupedErrors[year] = {};
        groupedErrors[year][role] = Object.keys(errors[year][role])
          .map((field) => errors[year][role][field])
          .join(", "); // Combine all error messages for the role
      });
    });

    return groupedErrors;
  };

  // Submit Handler

  // Table Data
  const rows = [
    {
      segment:
        "Number of complaints received in relation to issues of Conflict of Interest of the Directors",
      role: "directors",
    },
    {
      segment:
        "Number of complaints received in relation to issues of Conflict of Interest of the KMPs",
      role: "keyManagement",
    },
  ];

  return (
    <>
      <TableContainer
        component={Paper}
        sx={{
          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          borderRadius: "10px",
          ml: 2,
          width: "98%",
        }}
      >
        <Table>
          {/* Table Header */}
          <TableHead>
            <TableRow
              sx={{
                borderRadius: "10px",
                backgroundColor: "#1C486B",
                border: "1px solid #ddd",
              }}
            >
              {" "}
              <TableCell
                sx={{
                  color: "#fff",
                  fontWeight: "bold",
                  borderBottom: "none",
                  justifyContent: "center",
                }}
              >
                Segment
              </TableCell>
              <TableCell
                colSpan={2}
                sx={{
                  color: "#fff",
                  fontWeight: "bold",
                  textAlign: "left",
                  border: "1px solid #ddd",
                }}
              >
                Current Financial Year
              </TableCell>
              <TableCell
                colSpan={2}
                sx={{
                  color: "#fff",
                  fontWeight: "bold",
                  textAlign: "left",
                  border: "1px solid #ddd",
                }}
              >
                Previous Financial Year
              </TableCell>
            </TableRow>
            <TableRow
              sx={{
                borderRadius: "10px",
                backgroundColor: "#1C486B",
                border: "1px solid #ddd",
              }}
            >
              {" "}
              <TableCell sx={{ borderBottom: "1px solid #ddd" }}></TableCell>
              <TableCell
                sx={{
                  border: "1px solid #ddd",
                  color: "#fff",
                  fontWeight: "bold",
                }}
              >
                Number
              </TableCell>
              <TableCell
                sx={{
                  border: "1px solid #ddd",
                  color: "#fff",
                  fontWeight: "bold",
                }}
              >
                Remarks
              </TableCell>
              <TableCell
                sx={{
                  border: "1px solid #ddd",
                  color: "#fff",
                  fontWeight: "bold",
                }}
              >
                Number
              </TableCell>
              <TableCell
                sx={{
                  color: "#fff",
                  fontWeight: "bold",
                  border: "1px solid #ddd",
                }}
              >
                Remarks
              </TableCell>
            </TableRow>
          </TableHead>

          {/* Table Body */}
          <TableBody>
            {rows.map((row, index) => (
              <TableRow
                key={index}
                sx={{ border: "1px solid rgba(224, 224, 224, 1)" }}
              >
                {/* Segment */}
                <TableCell sx={{ width: "20rem" }}>{row.segment}</TableCell>
                {/* Current Financial Year */}
                {["numberOfComplaints", "remarks"].map((field) => (
                  <TableCell
                    key={`current-${row.role}-${field}`}
                    sx={{
                      border: "1px solid #DBDBDB",
                      py: "0.5rem",
                      height: "auto",
                    }}
                  >
                    <TextField
                      placeholder={`Enter ${
                        field === "remarks" ? "Text" : "Number"
                      }`}
                      disabled={disabled}
                      size="small"
                      variant="standard"
                      minRows={1}
                      fullWidth
                      value={
                        formData?.conflictOfInterestComplaints
                          ?.currentFinancialYear[row.role][field]===0? 0: formData?.conflictOfInterestComplaints
                          ?.currentFinancialYear[row.role][field] || ""
                      }
                      InputProps={{ disableUnderline: true }}
                      onChange={(e) =>
                        handleRowChange(
                          "currentFinancialYear",
                          row.role,
                          field,
                          e.target.value
                        )
                      }
                      multiline
                      sx={{
                        width: field === "remarks" ? "10rem" : "7rem",
                        py: "0.5rem",
                        "& .MuiInputBase-root": {
                          overflowY: "auto",
                          cursor: "default", // default cursor
                        },
                        "& .MuiInputBase-root:hover": {
                          cursor: "pointer", // pointer cursor on hover
                        },
                      }}
                    />
                  </TableCell>
                ))}
                {/* Previous Financial Year */}
                {["numberOfComplaints", "remarks"].map((field) => (
                  <TableCell
                    key={`previous-${row.role}-${field}`}
                    sx={{ border: "1px solid #DBDBDB", py: "0.5rem" }}
                  >
                    <TextField
                      placeholder={`Enter ${
                        field === "remarks" ? "Text" : "Number"
                      }`}
                      disabled={disabled}
                      size="small"
                      variant="standard"
                      fullWidth
                      InputProps={{ disableUnderline: true }}
                      value={
                        formData?.conflictOfInterestComplaints
                          ?.previousFinancialYear[row.role][field]===0? 0:formData?.conflictOfInterestComplaints
                          ?.previousFinancialYear[row.role][field] ||""
                      }
                      onChange={(e) =>
                        handleRowChange(
                          "previousFinancialYear",
                          row.role,
                          field,
                          e.target.value
                        )
                      }
                      multiline
                      rows={1}
                      sx={{
                        width: field === "remarks" ? "10rem" : "7rem",
                        py: "0.5rem",
                        "& .MuiInputBase-root": {
                          overflowY: "auto",
                          cursor: "default", // default cursor
                        },
                        "& .MuiInputBase-root:hover": {
                          cursor: "pointer", // pointer cursor on hover
                        },
                      }}
                    />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Error Messages Box */}
      <Box sx={{ mt: 1, ml: 2 }}>
        {Object.keys(getRowErrorMessages()).map((year) =>
          Object.keys(getRowErrorMessages()[year]).map((role, index) => (
            <p
              key={`${year}-${role}`}
              style={{
                lineHeight: "1.2",
                margin: "2px 0",
                color: "#d34040",
                fontSize: "10px",
                fontStyle: "italic",
              }}
            >
              {getRowErrorMessages()[year][role] &&
                `Row ${index + 1} : Missing fields - ${
                  role.startsWith("current")
                    ? "Current Financial Year"
                    : "Previous Financial Year"
                }  : ${getRowErrorMessages()[year][role]}`}
            </p>
          ))
        )}
      </Box>
    </>
  );
};

export default ComplaintTable;
